import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithoutRef } from 'react';
import ApplyBadge from './svg/apply-badge.svg';
import BuildingBadge from './svg/building-badge.svg';
import StarBadge from './svg/star-badge.svg';
const badgeVariants = cva(['rounded-xsmall', 'px-6 py-2', 'font-600 typo-caption1', 'inline-flex items-center gap-4', 'bg-Gray-200 text-Gray-700']);
interface BadgeProps extends ComponentPropsWithoutRef<'span'>, VariantProps<typeof badgeVariants> {
  icon?: 'building' | 'star' | 'apply';
}
const Badge = t0 => {
  const $ = _c(15);
  let children;
  let className;
  let icon;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      icon,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = icon;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    icon = $[3];
    props = $[4];
  }
  const Icon = icon === "building" ? BuildingBadge : icon === "star" ? StarBadge : null;
  if (icon === "apply") {
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ApplyBadge />;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn(badgeVariants(), className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== Icon) {
    t2 = Icon ? <Icon /> : null;
    $[8] = Icon;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== props || $[12] !== t1 || $[13] !== t2) {
    t3 = <span className={t1} {...props}>{t2}{children}</span>;
    $[10] = children;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export { Badge, type BadgeProps };